import { render, staticRenderFns } from "./footercommon.vue?vue&type=template&id=44ba2cf6&scoped=true&"
import script from "./footercommon.vue?vue&type=script&lang=js&"
export * from "./footercommon.vue?vue&type=script&lang=js&"
import style0 from "./footercommon.vue?vue&type=style&index=0&id=44ba2cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba2cf6",
  null
  
)

export default component.exports